import React from 'react';
import styles from './FinalCTASection.module.scss';

const FinalCTASection = ({ onGetAccess }) => {
  return (
    <section className={styles.finalCta} onClick={onGetAccess}>
      <img
        src="/Images/FinalCTASection.png"
        alt="Invest once. Create better content forever - Get lifetime access for $399 only"
        className={styles.sectionImage}
      />
    </section>
  );
};

export default FinalCTASection;
